(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purabelle-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var script = document.currentScript;
    var bar = script && script.closest ? script.closest('.pab') : null;
    if (!bar || bar.getAttribute('data-pab-sticky') !== 'true') return;

    var group = bar.parentElement;
    if (!group) return;

    var groupDisplay = '';
    try {
      groupDisplay = window.getComputedStyle(group).display;
    } catch (e) {}
    if (groupDisplay === 'contents') group.style.display = 'block';

    group.style.position = 'sticky';
    group.style.top = '0px';
    group.style.zIndex = '10';

    var header = group.querySelector('.header, header, [id^="shopify-section"] header');
    if (header) {
      var headerPosition = '';
      try {
        headerPosition = window.getComputedStyle(header).position;
      } catch (e) {}
      if (headerPosition === 'sticky') header.style.position = 'static';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purabelle-collection-tiles"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var script = document.currentScript;
      var section = script && script.closest ? script.closest('.pct') : null;
      if (!section) return;

      var track = section.querySelector('[data-pct-track]');
      var prev = section.querySelector('[data-pct-prev]');
      var next = section.querySelector('[data-pct-next]');
      if (!track || !prev || !next) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return 0;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var isDesktop = window.matchMedia('(min-width: 901px)').matches;
        prev.hidden = !isDesktop || track.scrollLeft <= 1;
        next.hidden = !isDesktop || track.scrollLeft >= max - 1;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purabelle-homepage-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('.pbh')
      : null;
    if (!root) return;

    root.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-hero-cta]');
      if (!cta) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cro_homepage_hero_cta_click',
        cta: cta.getAttribute('data-hero-cta') || '',
        href: cta.getAttribute('href') || ''
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
